<template>
  <div
    id="devmg"
    v-loading.fullscreen.lock="loading"
    element-loading-text="Waiting...."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >

      <h2>滚动信息公告条</h2>
      <div>
        <el-input
          class="input_oxiaom"
          type="textarea"
          placeholder="请输入内容"
          v-model="textarea"
          maxlength="50"
          show-word-limit
        ></el-input>
      </div>
      <div class="butt_oxiaom">
        <el-button type="warning"  @click="_reget_info"   icon="el-icon-refresh"      circle></el-button>
        <el-button type="danger"   @click="_resave_info"   icon="el-icon-circle-check" circle></el-button>
      </div>



  </div>


</template>
<style scoped>
#devmg {

  padding: 20px ;
  text-align:left ;
  width: 100%;
}
.butt_oxiaom{
  margin: 20px;
}
.input_oxiaom{
   width: 60%;
}
.el-table {
  margin: 20px ;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.edit_dev  {
	text-align:left ;
	/deep/ .el-transfer-panel {
		width:300px;
	}
}
</style>

<script>
import axios from "axios";
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
};
let Base64 = require("js-base64").Base64;
export default {
  data() {
    return {
      loading :false,
      devkindkind:0,
      textarea:""
    };
  },
  created(){
    this._reget_info();
  },
  methods: {
    _resave_info(){
      if(this.textarea.length < 5 ){
        this.$message({
          type: 'info',
          message: '公告信息太短了'
        });
        return;
      };
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      data.append("title", this.textarea);
      axios
        .post("/user/fnckukei/getswap_resave_info", data)
        .then(
          function(res) {
            if (res.data.res) {
                this.$message({
                  type: 'info',
                  message: '公告更新'
                });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    _reget_info(){
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      axios
        .post("/user/fnckukei/getswap_reget_info", data)
        .then(
          function(res) {
            if (res.data.res) {
                if(res.data.results.length > 0 ){
                    let one = res.data.results[0];
                    this.textarea = one.title;
                    this.$message({
                      type: 'info',
                      message: '公告信息已获取'
                    });
                }

            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    get_file_list() {
      axios
        .get("/Get_file_List_val.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd"),
            kind: "mp3"
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.tableDatafilelist = res.data.file;
              this.tableDatafilelist.forEach((item, index) => {
                item.filename = Base64.decode(item.filename);
                item.filesize = item.filesize;
              });
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/xxxvue/admin_fabuinfo.vue